module.exports = ":host{display:flex;flex-direction:column;width:100%}.buttonsBlock{display:flex;justify-content:space-around;align-items:center;height:20%}\n"